import React, { createContext, useState, useEffect, useContext } from 'react';
import i18n from '../i18n';

// 1. Create the Context (Name it 'Context', NOT 'Provider')
const LanguageContext = createContext();

// 2. Create the Provider Component
const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(i18n.language || 'en');

  useEffect(() => {
    const handleLanguageChange = (lang) => {
      setLanguageState(lang);
      localStorage.setItem('language', lang);
    };

    if (i18n) i18n.on('languageChanged', handleLanguageChange);
    return () => {
      if (i18n) i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  const setLanguage = (lang) => {
    if (i18n) i18n.changeLanguage(lang);
  };

  return (
    // We use .Provider here
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// 3. EXPORT DEFAULT THE COMPONENT (Not the context)
export default LanguageProvider;

// 4. Export the hook
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within a LanguageProvider');
  return context;
};